var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-accordion c-accordion--project-managers" },
    [
      _vm._t("buttonlabel"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-accordion__button",
          class: [_vm.isOpen ? _vm.activeClass : "is-active"],
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleContent.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "c-accordion__icon",
              class: [_vm.isOpen ? _vm.activeClass : "is-active"],
              attrs: { width: "40", height: "12" },
            },
            [
              _c("polyline", {
                attrs: {
                  points: "12,2 20,10 28,2",
                  "stroke-width": "3",
                  fill: "none",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "u-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen",
              },
            ],
            staticClass: "c-accordion__content u-extra-small-margin--top",
          },
          [_vm._t("content")],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }